module.exports = __webpack_public_path__ + "static/media/ev5.06f7d685.jpg";